import { types } from "../types/types";

const initialState = {
  loading: false,
  loaded: false,
  states: [],
  pendingReasons: [],
  cancelReasons: [],
  normalReasons: [],
  assignmentStrategies: [],
  eventTypes: [],
  ownerApprovals: [],
  inboxLoading: false,
  inbox: {
    moduleName: null,
    role: null,
    rows: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    filters: {}
  }
};

export const flowEngineReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FLOWENGINE_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case types.FLOWENGINE_SET_CATALOGS:
      return {
        ...state,
        ...action.payload,
        loaded: true
      };

    case types.FLOWENGINE_SET_INBOX_LOADING:
      return {
        ...state,
        inboxLoading: action.payload
      };

    case types.FLOWENGINE_SET_INBOX:
      return {
        ...state,
        inbox: {
          moduleName: action.payload?.moduleName || state.inbox.moduleName,
          role: action.payload?.role || state.inbox.role,
          rows: action.payload?.rows || [],
          totalItems: action.payload?.totalItems || 0,
          totalPages: action.payload?.totalPages || 0,
          currentPage: action.payload?.currentPage || 0,
          filters: action.payload?.filters || {}
        }
      };

    case types.AUTH_LOGOUT:
      return initialState;

    default:
      return state;
  }
};



